'use es6';

import http from 'hub-http/clients/apiClient';
import { BLOG_API_BASE_URL, TAGS_PER_PAGE } from '../Constants';
const url = `${BLOG_API_BASE_URL}/tags`;
function fetch(blogPostLanguage, search, page = 1) {
  return http.get(`${url}/search-assignable`, {
    query: {
      limit: TAGS_PER_PAGE,
      order: '-created',
      property: ['name', 'id', 'language'],
      blogPostLanguage,
      q: search,
      offset: TAGS_PER_PAGE * (page - 1)
    }
  });
}
function create(name, language) {
  return http.post(url, {
    data: {
      name,
      language
    }
  });
}
function createTranslation(masterId, masterLanguage, variationLanguage, variationName) {
  return http.post(`${url}/${masterId}/create-language-variation`, {
    data: {
      name: variationName,
      masterLanguage,
      language: variationLanguage
    }
  });
}
export default {
  create,
  fetch,
  createTranslation
};